// extracted by mini-css-extract-plugin
export default {"title__button":"TabTitle_title__button__V9xkh","active":"TabTitle_active__Sqghl","title":"TabTitle_title__ApT1b"};